module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "AuditsHeader my-3"
  }, [_c('v-row', {
    staticClass: "headerCaption",
    attrs: {
      "align-start": "",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pa-0 py-2 text-center text-md-left fill-height overflow-hidden",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t("Audits.Header.audits", [_vm.orgName])))])]), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 py-2 text-center text-md-right no-wrap d-flex",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [((_vm.userRoles && _vm.userRoles.isAdmin) || _vm.allowedOrganizations.length > 0) ? _c('OrganizationFilter', {
    attrs: {
      "allowedOrgs": _vm.allowedOrganizations,
      "selectedOrganization": _vm.selectedOrganization,
      "solo": _vm.solo,
      "outline": _vm.outline
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    staticClass: "DateSelector ma-0 ml-3",
    attrs: {
      "items": _vm.optionsDates,
      "item-text": "label",
      "item-value": "id",
      "solo": "",
      "height": "40px",
      "append-icon": "",
      "single-line": "",
      "flat": "",
      "dense": "",
      "color": "black",
      "loading": _vm.loadingQuery && '#0098E1',
      "hide-details": ""
    },
    on: {
      "click": _vm.openDateSelector
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-icon', {
          attrs: {
            "color": "black"
          }
        }, [_vm._v("date_range")])]
      },
      proxy: true
    }, _vm._l((['item', 'selection']), function(slotName) {
      return {
        key: slotName,
        fn: function(data) {
          return [_c('div', {
            staticClass: "AuditDateItem",
            attrs: {
              "slot": "item"
            },
            slot: "item"
          }, [(data.item.haveNonPublishedAudits === true) ? _c('v-icon', {
            attrs: {
              "small": "",
              "color": "warning"
            }
          }, [_vm._v("priority_high")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.label))])], 1)]
        }
      }
    })], null, true),
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a54d111a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Audits/Header.vue
// module id = 1740
// module chunks = 0